/**
 * 获取联系人列表、推荐人
 * @author fredhaochen
 */
import { useState, useEffect } from 'react'
import { getCustomerContactInfoList } from '@services/customer'
import { ContactInfoItem, ContactInfoStatusTypeEnum, ContactInfoFilter } from '@types'
import { message } from 'antd'

export function useContactInfoService (cid: string = '', extraFilter?: Partial<ContactInfoFilter>) {
  const [contactInfoList, setContactInfoList] = useState<ContactInfoItem[]>()
  const [contactLoading, setContactLoading] = useState(true)
  const [flag, setFlag] = useState(0)
  const [recommendedContact, setRecommendedContact] = useState<ContactInfoItem>({})

  useEffect(() => {
    if (cid) {
      (async () => {
        setContactLoading(true)
        const filter = { cid, ...extraFilter }
        const [res, err] = await getCustomerContactInfoList(filter)
        setContactLoading(false)
        if (err) {
          message.error('获取联系人信息失败' + err.message)
        }

        let list = Array.from(res?.list || [])
        const recommendContactIndex = list.findIndex(item => item.status === ContactInfoStatusTypeEnum.RECOMMENDED)
        setRecommendedContact(list[recommendContactIndex])

        // 联系人列表，按状态排序，展示顺序为：优先推荐、有效、未验证、无效、拒绝联系
        const recommendedListContact = list.filter(item => item.status === ContactInfoStatusTypeEnum.RECOMMENDED)
        const validListContact = list.filter(item => item.status === ContactInfoStatusTypeEnum.VALID)
        const noVerifiedListContact = list.filter(item => item.status === ContactInfoStatusTypeEnum.NOT_VERIFIED)
        const invalidListContact = list.filter(item => item.status === ContactInfoStatusTypeEnum.INVALID)
        const blackListContact = list.filter(item => item.status === ContactInfoStatusTypeEnum.BLACKLIST)

        list = [].concat(recommendedListContact, validListContact, noVerifiedListContact, invalidListContact, blackListContact)

        setContactInfoList(list)
      })()
    } else {
      setContactInfoList([])
      setRecommendedContact({})
    }
  }, [cid, flag, extraFilter])

  const forceRequest = () => setFlag(f => f + 1)

  return [contactLoading, contactInfoList, recommendedContact, forceRequest] as const
}
